//hook
import { NotificationConsumer } from '../hooks/context/NotificationContext';

//mui
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const Notification = () => {
    let {NoteMessage, showMessage, setShowMessage, statusCode} = NotificationConsumer()
  return (
    <div>
    <Snackbar
        open={showMessage}
        autoHideDuration={2500}
        onClose={()=>setShowMessage(false)}
      >
        {statusCode == 200
        ? 
        <Alert variant="filled" severity="success">
            {NoteMessage}
        </Alert>
        :
        <Alert variant="filled" severity="error">
            {NoteMessage}
        </Alert>
        }
      </Snackbar>
    </div>
  )
}

export default Notification